<template>
  <div
    id="date-range-title"
    class="cursor-pointer d-flex align-center gap-4 justify-center pl-12 pl-md-0 mx-auto mx-md-0 text-no-wrap flex-nowrap"
    @click.stop="showCalendarSelect = !showCalendarSelect"
  >
    <span class="d-none d-md-block text-capitalize font-weight-bold text-size-plus-7">
      {{ calendarTitle }}
    </span>
    <span 
      :class="{
        'line-clamp-1': $vuetify.display.smAndDown,
      }"
      class="d-md-none text-size-plus-2 text-capitalize font-weight-bold"
    >
      {{ truncatedCalendarTitle }}
    </span>
    <v-icon
      size="36"
    >
      arrow_drop_down
    </v-icon>
  </div>

  <v-btn
    icon
    flat
    :size="$vuetify.display.mdAndUp ? 48 : 36"
    class="ml-4"
    v-tooltip:left="'Filter Events'"
    @click="$emit('filter')"
    v-if="$route?.name?.startsWith('calendar')"
  >
    <v-icon
      outlined
    >
      filter_alt
    </v-icon>
  </v-btn>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {mapActions, mapWritableState} from 'pinia'
import moment from 'moment'
import {useCalendarStore} from '@/stores/calendar'
import {CalendarViews} from '@/enums/calendarViews'
import months from '@/data/months'
import {trim} from 'lodash'

export default defineComponent({
  name: 'CalendarNav',
  emits: ['filter'],
  computed: {
    ...mapWritableState(useCalendarStore, ["showCalendarSelect", 'calendarStart', 'calendarView']),


    calendarTitle() {
      this.$auth.user?.settings?.start_of_week
      switch (this.calendarView) {
        case CalendarViews.YEAR:
          return moment(this.calendarStart).format('YYYY')
        case CalendarViews.MONTH:
          return moment(this.calendarStart).format('MMMM YYYY')
        case CalendarViews.WEEK:
          if (this.$vuetify.display.smAndUp) {
            return `${moment(this.calendarStart).startOf('week').format('MMM D')} - ${moment(this.calendarStart).endOf('week').format('MMM D')}, ${moment(this.calendarStart).format('YYYY')}`
          } else {
            return `${moment(this.calendarStart).format('MMM D')} - ${moment(this.calendarStart).add(1, 'day').format('MMM D')}, ${moment(this.calendarStart).format('YYYY')}`
          }
        default:
          return moment(this.calendarStart).format('MMM D, YYYY')
      }
    },
    truncatedCalendarTitle() {
      let title = this.calendarTitle
      months.forEach(month => {
        title = title.replace(month.name, month.abbr)
      })
      if (title.length > 8 && title.slice(-4).match(/^\d+$/)) {
        title = trim(title.slice(0, -4).trim(), ',')
      }
      return title
    }
  },
  methods: {
    ...mapActions(useCalendarStore, ['setDate'])
  }
})
</script>